import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAdminAuth } from '../../contexts/AdminAuthContext';
import { FaLock, FaUser } from 'react-icons/fa';

export default function AdminLogin() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAdminAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const result = await login(username, password);
      
      if (result.success) {
        // Clear redirect path from session storage
        sessionStorage.removeItem('redirectAfterLogin');
        // Navigate to the redirect path or default to jobs
        navigate(result.redirectPath || '/admin/jobs');
        // Note: We don't set loading to false here because we're navigating away
        return;
      } else {
        setError(result.message || 'Login failed');
      }
    } catch (error) {
      console.error('Login submission error:', error);
      setError('An unexpected error occurred. Please try again.');
    } finally {
      // Always reset loading state, even if navigation happens
      setLoading(false);
    }
  };

  return (
    <div className="min-vh-100 d-flex align-items-center justify-content-center" style={{ background: '#f8f9fa' }}>
      <div className="container" style={{ maxWidth: '400px' }}>
        <div className="card shadow-sm border-0">
          <div className="card-body p-5">
            <div className="text-center mb-4">
              <h2 className="fw-bold" style={{ color: '#2E4374' }}>Admin Login</h2>
              <p className="text-muted">Enter your credentials to access the admin panel</p>
            </div>

            {error && (
              <div className="alert alert-danger" role="alert">
                {error}
              </div>
            )}

            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label className="form-label">Username or Email</label>
                <div className="input-group">
                  <span className="input-group-text">
                    <FaUser />
                  </span>
                  <input
                    type="text"
                    className="form-control"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    required
                    autoFocus
                  />
                </div>
              </div>

              <div className="mb-4">
                <label className="form-label">Password</label>
                <div className="input-group">
                  <span className="input-group-text">
                    <FaLock />
                  </span>
                  <input
                    type="password"
                    className="form-control"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                </div>
              </div>

              <button
                type="submit"
                className="btn w-100 py-2 fw-semibold"
                style={{ background: '#2E4374', color: 'white' }}
                disabled={loading}
              >
                {loading ? 'Logging in...' : 'Login'}
              </button>
              
              {loading && (
                <div className="mt-2 text-center">
                  <small className="text-muted">
                    If this is your first request, the server may take up to 60 seconds to wake up.
                  </small>
                </div>
              )}
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}


